'use client';

import * as React from 'react';
import {
  APP_SETTINGS_EVENT,
  loadAppSettings,
  patchAppSettings,
  type AppSettings,
} from './appSettings';

export function useAppSettings(defaults?: Partial<AppSettings>) {
  const [settings, setSettings] = React.useState<AppSettings>(() => loadAppSettings(defaults));

  React.useEffect(() => {
    const sync = () => setSettings(loadAppSettings(defaults));
    sync();
    window.addEventListener(APP_SETTINGS_EVENT, sync);
    return () => window.removeEventListener(APP_SETTINGS_EVENT, sync);
  }, [defaults]);

  const update = React.useCallback(
    (patch: Partial<AppSettings>, options?: { skipUsername?: boolean }) => {
      const next = patchAppSettings(patch, options);
      setSettings(next);
      return next;
    },
    [],
  );

  return { settings, update };
}
